<template lang='pug'>
  div
    v-dialog(v-model='dialog', width='1100')
      v-card
        v-card-title.headline.primary.white--text(primary-title)
          |  Modelos
        v-card-text(style="height: 500px")
          v-container.pa-0(fluid grid-list-lg)
            v-layout(row wrap)
              v-flex(sm4)
                v-card
                  v-card-text.pa-0
                    v-text-field.px-3.pb-2(
                      v-model="search"
                      label="Procurar"
                      append-icon="search"
                      hide-details
                      single-line
                    )
                    v-list(dense style="max-height: 390px; overflow: auto;")
                      v-subheader Modelos da Empresa
                      v-list-tile(
                        v-for='item in companyTemplates'
                        :key='item.iuid'
                        @click='setTemplate(item)'
                      )
                        v-list-tile-content(:title='item.name')
                          v-list-tile-title(v-text='item.name')

                      v-divider
                      v-subheader Modelos Padrão do Sistema
                      v-list-tile(
                        v-for='item in systemTemplates'
                        :key='item.iuid'
                        @click='setTemplate(item)'
                      )
                        v-list-tile-content(:title='item.name')
                          v-list-tile-title(v-text='item.name')

                      v-divider

                      v-list-tile(v-if="!isSystemTemplate" @click='newTemplate')
                        v-list-tile-action
                          v-icon(color="primary") add_circle_outline
                        v-list-tile-content(title='Novo modelo')
                          v-list-tile-title Novo modelo

                      v-list-tile(v-if="isAdmin" @click='newSystemTemplate')
                        v-list-tile-action
                          v-icon(color="primary") add_circle_outline
                        v-list-tile-content(title='Novo modelo do sistema')
                          v-list-tile-title Novo modelo padrão
              v-flex(sm8)
                v-layout(row)
                  v-flex(grow)
                    v-text-field.my-1(
                      label="Nome"
                      v-model="template.name"
                      hide-details
                      solo
                      )
                  v-flex(shrink)
                    v-btn(color="success" @click="save") Salvar
                    v-btn(color="error" @click="remove" outline v-if="template.iuid") Remover
                v-card
                  v-card-text
                    tinymce-editor(
                      v-if="dialog"
                      v-model="template.content"
                      :api-key="apiKey"
                      :init="initObj"
                      :toolbar="toolbar"
                      id="editorModels"
                      )
        v-divider
        v-card-actions
          v-spacer
          v-btn(color='default', flat, @click='dialog = false') Fechar
          v-btn(color='primary', :disabled="template.iuid ? false : true", @click="apply") Aplicar
</template>

<script>
import _ from 'lodash'
import { core, db } from '@/store/firebase'
import { mapState } from 'vuex'

export default {
  name: 'mask-report-dialog',

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      templates: state => state.ultraFetal.templates,
      company: state => state.company,
      companyUltraFetal: state => state.ultraFetal.company,
      user: state => state.user
    }),
    isAdmin () {
      return this.user && this.user.role === 'admin'
    },
    isSystemTemplate () {
      return this.template && this.template.isSystem
    },
    systemTemplates () {
      const patternUpper = this.search.toUpperCase()
      return this.templates.filter(template => {
        return template.isSystem &&
               template.name.toUpperCase().indexOf(patternUpper) !== -1
      })
    },
    companyTemplates () {
      const patternUpper = this.search.toUpperCase()
      return this.templates.filter(template => {
        return !template.isSystem &&
               template.name.toUpperCase().indexOf(patternUpper) !== -1
      })
    },
    items () {
      const patternUpper = this.search.toUpperCase()
      return this.templates.filter(function (char) {
        return char.name.toUpperCase().indexOf(patternUpper) !== -1
      })
    }
  },

  watch: {
    value (val) {
      this.dialog = val
      this.reset()
    },
    dialog (val) {
      this.$emit('input', val)
    }
  },

  data () {
    return {
      dialog: false,
      isVisible: false,
      template: {},
      search: '',
      editorModels: null,
      apiKey: process.env.TINYMCE_API_KEY,
      toolbar: 'myCustomMenuItem | insertKeyWord | myCustomDropDown | undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment',
      initObj: {
        menubar: false,
        statusbar: false,
        min_height: 350,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen pagebreak',
          'insertdatetime media table paste code help wordcount'
        ],
        setup: async (editorModels) => {
          editorModels.ui.registry.addButton('insertKeyWord', {
            text: 'Palavra-chave',
            onAction: () => (editorModels.insertContent(`<span class="${'key'}">${'{x}'}</span> `))
          })
        }
      }
    }
  },

  async mounted () {
    await this.$store.dispatch('ultraFetal/getCompany', this.company)
    await this.$store.dispatch('ultraFetal/initListTemplates')
  },

  methods: {
    async save () {
      const model = this.template

      if (model.isSystem && !this.isAdmin) {
        this.$awn.alert('Você não tem permissão para editar modelos padrão do sistema.')
        return
      }

      let payload = {
        name: model.name,
        content: model.content || '',
        isSystem: model.isSystem || false,
        company: model.isSystem ? null : {
          id: this.companyUltraFetal.iuid,
          identity: this.companyUltraFetal.identity
        }
      }

      try {
        if (!model.iuid) {
          await this.saveNew(payload)
          this.$awn.success(`Salvo com sucesso!`)
        } else {
          await this.saveUpdate(model.iuid, payload)
          this.$awn.success(`Salvo com sucesso!`)
        }

        // Recarrega a lista de templates após salvar
        await this.$store.dispatch('ultraFetal/initListTemplates')
        this.template = payload
      } catch (error) {
        console.error('Erro ao salvar template:', error)
        this.$awn.alert('Erro ao salvar o template.')
      }
    },

    async saveNew (payload) {
      const collection = db.collection('templates')
      const body = payload.content
      delete payload.content

      const addResponse = await collection.add(payload)
      const { id } = addResponse
      payload.currentContent = await this.saveSubcollectionContent(id, body)
      await collection.doc(id).set(payload, { merge: true })
      payload.iuid = id
    },

    async saveUpdate (idTemplate, payload) {
      const collection = db.collection('templates')
      const body = payload.content
      delete payload.content

      payload.currentContent = await this.saveSubcollectionContent(idTemplate, body)
      await collection.doc(idTemplate).set(payload, { merge: true })
      payload.iuid = idTemplate
    },

    async saveSubcollectionContent (idTemplate, body) {
      const addResponse = await db.doc(`templates/${idTemplate}`).collection('contents').add({
        body,
        created: core.firestore.FieldValue.serverTimestamp()
      })
      return addResponse.id
    },

    async remove () {
      try {
        const { iuid, name, isSystem } = this.template

        if (isSystem && !this.isAdmin) {
          this.$awn.alert('Você não tem permissão para remover modelos padrão do sistema.')
          return
        }

        var confirmed = confirm(`Deseja remover '${name}'?`)
        if (!confirmed) return

        await db.collection('templates').doc(iuid).delete()

        // Recarrega a lista de templates após remover
        await this.$store.dispatch('ultraFetal/initListTemplates')

        this.$awn.success(`'${name}' foi removido com sucesso!`)
        this.template = {}
      } catch (e) {
        this.$awn.alert(`Erro ao remover o modelo ${name}.`)
        console.error(e)
      }
    },
    async setTemplate (payload) {
      let tmpTemplate = _.cloneDeep(payload)

      if (tmpTemplate.currentContent) {
        const query = await db.doc(`templates/${tmpTemplate.iuid}/contents/${tmpTemplate.currentContent}`).get()
        if (query.exists) tmpTemplate.content = query.data().body
      }

      this.template = tmpTemplate
    },
    newTemplate () {
      this.template = { name: this.search, content: '' }
      this.search = ''
    },
    reset () {
      this.template = { name: '', content: '' }
      this.search = ''
    },
    apply () {
      this.$emit('apply', this.template.content)
      this.$emit('input', false)
    },
    newSystemTemplate () {
      if (!this.isAdmin) {
        this.$awn.alert('Você não tem permissão para criar modelos padrão do sistema.')
        return
      }
      this.template = {
        name: this.search,
        content: '',
        isSystem: true
      }
      this.search = ''
    }
  }
}
</script>

<style lang='stylus' scoped>
</style>



// WEBPACK FOOTER //
// src/components/editor/TemplateDialog.vue